<script lang="ts" setup>
const { isFullWidthLayout } = useLayoutStore()
</script>

<template>
  <div :class="[isFullWidthLayout ? 'app-layout-fullwidth' : 'app-layout']">
    <slot />
  </div>
</template>

<style scoped lang="scss">
  .app-layout {
    max-width: var(--app-max-width);
    padding: 0 24px;
    margin: 0 auto;

    @include vgs-media-mobile {
      max-width: 100vw;
    }
  }

  .app-layout-fullwidth {
    max-width: var(--app-full-width);
    padding: 0;
    margin: 0 auto;
  }
</style>
